import { action } from 'satcheljs';
import { ServiceRequestDataPoint } from '../store/schema/DiagnosticsLogState';

export const logServiceRequestDiagnostics = action(
    'LogServiceRequestDiagnostics',
    (datapoint: ServiceRequestDataPoint) => ({ datapoint })
);

export const registerServiceRequestDiagnostics = action('RegisterServiceRequestDiagnostics');

export const selectServiceDiagnosticsItem = action(
    'SelectServiceDiagnosticsItem',
    (key: string | number) => ({ key })
);
